import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { Button } from '@hh.ru/magritte-ui-button';
import { ArrowPathClockwiseOutlinedSize24 } from '@hh.ru/magritte-ui-icon/variants/icon';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';
import { Title } from '@hh.ru/magritte-ui-title';
import { Text } from '@hh.ru/magritte-ui-typography';

var styles = {"error-container":"magritte-error-container___t9B5w_10-0-16","errorContainer":"magritte-error-container___t9B5w_10-0-16"};

const SelectError = ({ innerErrorTrls, reload, }) => {
    const { isMobile } = useBreakpoint();
    if (isMobile) {
        return (jsxs("div", { className: styles.errorContainer, children: [jsx(Title, { Element: 'h3', size: "small", children: innerErrorTrls.title }), jsx(VSpacing, { default: 8 }), jsx(Text, { typography: "paragraph-2-regular", style: "secondary", children: innerErrorTrls.description })] }));
    }
    return (jsxs("div", { className: styles.errorContainer, "data-qa": "magritte-select-error", children: [jsx(Title, { Element: 'h3', size: "small", children: innerErrorTrls.title }), jsx(VSpacing, { default: 8 }), jsx(Text, { typography: "paragraph-2-regular", style: "secondary", children: innerErrorTrls.description }), jsx(VSpacing, { default: 32 }), jsx(Button, { mode: "primary", style: "accent", size: "medium", onClick: reload, icon: jsx(ArrowPathClockwiseOutlinedSize24, {}), children: innerErrorTrls.reloadButton })] }));
};

export { SelectError };
//# sourceMappingURL=SelectError.js.map
